export default function DateDivider({ label }) {
  return (
    <div className="flex items-center justify-center py-2">
      <div className="rounded-full bg-white/90 dark:bg-slate-800/90 px-4 py-1.5 text-xs font-medium text-gray-600 dark:text-slate-300 shadow-sm border border-gray-200/80 dark:border-slate-700/80">
        {label}
      </div>
    </div>
  );
}